export default __webpack_public_path__ + "static/media/Ducks.d3d14095.png";